import { call, put, takeLatest } from "redux-saga/effects";
import { truongApi } from "../../../api/category/truongApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eTruongActionTypeIds } from "../../action-types/category/ITruongActionType";
import { actions } from "../../actions";

export function* truongSaga(): any {
    yield takeLatest(eTruongActionTypeIds.LOAD_START, loadWorker)
}
function* loadWorker(): any {
    const res: IBaseRespone = yield call(truongApi.getAll)
    if (res.is_success) {
        yield put(actions.truong.loadSuccess(res.data))
    } else {
        yield put(actions.truong.loadError(res.message))
    }
}